const submitLocks = new WeakMap()

/*函数节流*/
function throttle(fn, interval) {
  let enterTime = 0 //触发的时间
  let gapTime = interval || 300 //间隔时间，如果interval不传，则默认300ms
  return function() {
    let context = this
    let args = arguments
    let backTime = new Date() //第一次函数return即触发的时间
    if (backTime - enterTime > gapTime) {
      fn.apply(context, args)
      enterTime = backTime //赋值给第一次触发的时间，这样就保存了第二次触发的时间
    }
  }
}

/*函数防抖*/
function debounce(fn, interval) {
  let timer
  let gapTime = interval || 500 //间隔时间，如果interval不传，则默认1000ms
  return function() {
    clearTimeout(timer)
    let context = this
    let args = arguments //保存此处的arguments，因为setTimeout是全局的，arguments不是防抖函数需要的。
    timer = setTimeout(function() {
      fn.apply(context, args)
    }, gapTime)
  }
}

/**
 * 异步提交锁。同一组件中相同 key 的任务未结束时，忽略后续重复调用。
 * 无论任务成功或失败，都会在 finally 中释放锁，确保下次仍可提交。
 */
async function submitOnce(context, key, task) {
  if (!context || typeof context !== 'object') {
    throw new TypeError('submitOnce requires a component context')
  }
  if (typeof task !== 'function') {
    throw new TypeError('submitOnce requires a task function')
  }

  let locks = submitLocks.get(context)
  if (!locks) {
    locks = new Set()
    submitLocks.set(context, locks)
  }

  const lockKey = key || task
  if (locks.has(lockKey)) return

  locks.add(lockKey)
  try {
    return await task.call(context)
  } finally {
    locks.delete(lockKey)
    if (!locks.size) submitLocks.delete(context)
  }
}

export default {
  throttle,
  debounce,
  submitOnce
}
